
import { defineComponent, computed, ref } from "vue";
import { useStore } from "vuex";

export default defineComponent({
  name: "CountrySelect",
  emits: ["change"],
  setup(props, { emit }) {
    const store = useStore();
    const selectedRegion = ref<number | null>(null);

    const countries = computed(() => {
      return [
        {
          id: -1,
          name: "Rivenditori vicino a me",
          isoCode: "",
        },
        ...store.state.countries,
      ];
    });

    const cities = computed(() => {
      return [
        {
          id: -1,
          name: "Seleziona regione",
        },
        ...store.state.cities,
      ];
    });

    const isItalian = computed(() => {
      return store.getters.hasProvince;
    });

    const selectedCountry = computed<string | null>(() => {
      return store.state.filters.country;
    });

    const onChangeCountry = (e: any) => {
      emit("change", {
        country: e.target.value === "" ? null : (e.target.value as any),
        region: selectedRegion.value,
      });
    };

    const onChangeRegion = (e: any) => {
      emit("change", {
        country: selectedCountry.value,
        region: e.target.value as any,
      });
    };

    return {
      countries,
      cities,
      isItalian,
      onChangeCountry,
      onChangeRegion,
    };
  },
});
